import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import type { WeeklyLeaderboardOriginFeature } from 'src/replicant/weeklyLeaderboard/weeklyLeaderboard.analytics.schema';

export default abstract class BaseLeaderboardsPage extends View {
  protected abstract header: ImageScaleView;
  protected abstract contentView: View;
  protected onShow?: () => void;
  public originFeature: WeeklyLeaderboardOriginFeature = 'hud';

  constructor(superview: View) {
    super({
      superview,
      width: superview.style.width,
      height: superview.style.height,
      backgroundColor: '#C2AC80',
    });
  }

  public show() {
    super.show();
    this.onShow?.();
  }
}
